import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export type SortableHandleRenderArgs = {
  attributes: Record<string, any>;
  listeners: Record<string, any>;
  setActivatorNodeRef: (element: HTMLElement | null) => void;
  disabled: boolean;
  isDragging: boolean;
};

type SortableItemProps = {
  id: string;
  disabled?: boolean;
  children: React.ReactNode;
  handle?: (args: SortableHandleRenderArgs) => React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  contentClassName?: string;
  contentStyle?: React.CSSProperties;
  gap?: number;
};

const SortableItem = ({
  id,
  disabled = false,
  children,
  handle,
  className,
  style,
  contentClassName,
  contentStyle,
  gap = 8,
}: SortableItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  return (
    <div
      ref={setNodeRef}
      className={className}
      style={{
        ...style,
        transform: CSS.Transform.toString(transform),
        transition,
      }}
    >
      <div className="d-flex align-items-start" style={{ gap }}>
        {handle
          ? handle({
              attributes: disabled ? {} : (attributes as any),
              listeners: disabled ? {} : (listeners as any),
              setActivatorNodeRef: disabled
                ? () => undefined
                : setActivatorNodeRef,
              disabled,
              isDragging,
            })
          : null}
        <div
          className={contentClassName}
          style={{ flex: 1, minWidth: 0, ...contentStyle }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default SortableItem;
